import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { roundValue, safeParseFloat } from "lib/number";
import memoizeOne from "memoize-one";
import { getChildrenUnits, getGrandTotalUnit } from "../column-formula/units";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";

const memoGetGrandTotalUnit = memoizeOne(
    (factoryOptions, getterParams) => {
        return referenceMetricValueOrCompute(
            () => {
                let totalUnits = 0;
                getterParams.api.forEachNodeAfterFilter((rowNode) => {
                    // We only need to include outer row. `getGrandTotalUnit` will count nested children
                    if (rowNode.level === 0) {
                        totalUnits += getGrandTotalUnit(factoryOptions, {
                            ...getterParams,
                            node: rowNode,
                            data: rowNode.data,
                        });
                    }
                });

                return totalUnits;
            },
            getterParams,
            MetricsKind.UNITS,
            undefined,
            undefined,
            factoryOptions.disableSiblingOptimization
        );
    },
    (newArgs, oldArgs) => newArgs[1].colDef.colId === oldArgs[1].colDef.colId
);

export const UNIT_DOOR_PERCENTAGE_PLAN = ({ factoryOptions, getterParams }) => {
    const totalUnits = referenceMetricValueOrCompute(
        () => {
            let totalUnits = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                // We only need to include outer row. `getChildrenUnits` will count nested children
                if (rowNode.level === 0) {
                    totalUnits += getChildrenUnits(factoryOptions, {
                        ...getterParams,
                        node: rowNode,
                        data: rowNode.data,
                    });
                }
            });

            return totalUnits;
        },
        getterParams,
        MetricsKind.UNITS,
        undefined,
        undefined,
        factoryOptions.disableSiblingOptimization
    );

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (!totalUnits) {
        return 0;
    }

    // For grand total, this will always be 100
    if (totalUnits > 0 && getterParams.column.getColDef().type === ColumnTypes.AllDimensionTotal) {
        return 100;
    }

    // Get aggregrated total units of a node group across all deliveries and groups
    const grandTotalUnits = memoGetGrandTotalUnit(factoryOptions, getterParams);

    const unitDoorPercentagePlan = safeParseFloat(totalUnits / grandTotalUnits, 0) * 100;
    const roundedValue = roundValue(unitDoorPercentagePlan, 1);
    if (roundedValue === 0) {
        return "";
    }
    return roundedValue;
};
